// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'http://cd-api.smt-staging.com.ng/api/v1',
  // API_URL: 'http://uplsv.com.ng/kyc/public/api/v1',
  // API_URL: 'http://localhost:2015/api/fiap',
  // API_URL: 'https://jsonplaceholder.typicode.com',
  API_VERSION: 'v1',
  JWT_KEY: 'oiuytrertyu',
  SIGNUP: 'MwareCollege_2856',
  FORGOT: 'MwareCollege_494595',
  TOKEN: 'MwareCollegeDreamsWeb_token_3456789',
  ROLE: 'MwareCollegeDreamsWeb_role_97323456',
  TOKEN_DATE: 'MwareCollegeDreamsWeb_date_97323456',
  DATE_NOW: 'MwareCollegeDreamsWeb_date_now_956323456',
  PRIVATE_KEY: `3MwareCollegeDreamsWebgfdertyuhghgfrtyhbdrtyuytfhtrtyuhgghtrdfgytdghtrtre2345678uyfdvcxsaqq5wertyuijbvcxdffdcvgfghyt6t`,
  USERTOKEN: 'MwareCollegeDreamsWeb_user_56789',
  USERID: 'fiap_upperlink_user_id',
  TOKENEXPIRYCOUNT: 'token_expiry_count',
  ACTION_KEY: '12384-MwareCollegeDreamsWeb9-2tred;sdfguytr08j-987to890pojrt9-2tred;sdfguytr08j-iruobeakhigbe',
  URL_VALIDATION:  /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi,
  CODE_VALIDATION: 'Mware_Verify_Code_122234445',
  EMAIL_VALIDATION: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
